import { Navigate, Outlet } from "react-router-dom";
import { decodeAccessToken } from "../helpers/helpers";

const RoleProtectedRoute = ({ allowedRoles }) => {
  const user = decodeAccessToken();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // If user's role is not allowed → redirect
  if (!allowedRoles.includes(user.role.toLowerCase())) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <Outlet />;
};

export default RoleProtectedRoute;
